import ApiRequest from '../request'

export default class Invoices {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async create(data) {
    try {
      const res = await this.apiRequest.post(`invoices1`, data)
      return res
    } catch (error) {
      return error.response
    }
  }
}
